import React from 'react';
import { Button } from '@vwfs-bronson/bronson-react';
import { useAnalyticsActionTracker } from '@cp-shared-19/frontend-ui';
import { useTranslation } from 'react-i18next';
import { MarketingCard } from '../utils';

type MarketingCardButtonProps = {
    cardType: 'MAINTENANCE_SUBSCRIPTION' | 'MOTOR_INSURANCE';
    brand?: string;
    isMultipleMatch?: boolean;
    onlineServicePlanUrl?: string;
    content?: MarketingCard;
    buttonText?: string;
    buttonLink?: string;
};

export const MarketingCardButton: React.FC<MarketingCardButtonProps> = ({
    brand,
    isMultipleMatch,
    cardType,
    onlineServicePlanUrl,
    content,
    buttonText,
    buttonLink,
}) => {
    const { onAction } = useAnalyticsActionTracker('onClickMarketingCard');
    const { t } = useTranslation('contracts');

    if (!content) return null;

    const { maintenanceSubscription, motorInsurance } = content;

    const getLinkBrand = () => {
        switch (brand?.toLocaleLowerCase()) {
            case 'audi':
                return 'audi';
            case 'seat':
                return 'seat';
            case 'skoda':
                return 'skoda';
            default:
                return 'vw';
        }
    };

    const linkBrand = getLinkBrand();

    const handleClick = () => {
        const link =
            cardType === 'MAINTENANCE_SUBSCRIPTION'
                ? `${onlineServicePlanUrl}${maintenanceSubscription.traciLinks[linkBrand]}`
                : buttonLink || motorInsurance.links[linkBrand];
        const title = cardType === 'MAINTENANCE_SUBSCRIPTION' ? maintenanceSubscription.title : motorInsurance.title;
        onAction(title);
        window.open(link, '_blank', 'noopener,noreferrer');
    };

    let text = '';
    if (buttonText) text = buttonText;
    else if (cardType === 'MAINTENANCE_SUBSCRIPTION') text = maintenanceSubscription.buttonText;
    else {
        text = isMultipleMatch
            ? `${motorInsurance.buttonText.multipleMatches} ${linkBrand}`
            : motorInsurance.buttonText.oneMatch;
    }
    if (!text) return null;

    return (
        <Button
            link={true}
            icon="semantic-forward"
            iconReversed
            small
            onClick={handleClick}
            element="a"
            aria-label={cardType === 'MAINTENANCE_SUBSCRIPTION' ? t('btn-aria.aria-title2') : t('btn-aria.aria-title1')}
            title={cardType === 'MAINTENANCE_SUBSCRIPTION' ? t('btn-aria.aria-title2') : t('btn-aria.aria-title1')}
        >
            {text}
        </Button>
    );
};
